// extracted by mini-css-extract-plugin
export default {"heading":"BasicInformation_heading__2lJe1","wrapper":"BasicInformation_wrapper__xdne-"};